export default "__VITE_ASSET__AXMY$CDP__"